// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.step-progress {
    display: flex;
    width: 100%;
    overflow-x: auto;
    overflow-y: hidden;
    font-family: Arial, sans-serif;
    padding: 0px;
    border-radius: 0px;
}

.step-progress::-webkit-scrollbar {
    height: 8px;
}

.step-progress::-webkit-scrollbar-track {
    background: #ddd;
    border-radius: 4px;
}

.step-progress::-webkit-scrollbar-thumb {
    background-color: #ff9800;
    border-radius: 4px;
    border: 2px solid #ccc;
}

.step-progress {
    scrollbar-width: thin;
    scrollbar-color: #ff9800 #ddd;
}

.step {
    position: relative;
    padding: 6px 20px;
    background-color: #e4e4e4;
    color: #333;
    font-weight: bold;
    font-size: 11px;
    text-align: center;
    min-width: 85px;
    clip-path: polygon(0% 0%,
            calc(100% - 20px) 0%,
            100% 50%,
            calc(100% - 20px) 100%,
            0% 100%,
            20px 50%);
    flex-shrink: 0;
    transition: background 0.3s, color 0.3s;
}

.step.with-arrow::after {
    content: "";
    position: absolute;
    right: 0;
    top: 0;
    height: 100%;
    width: 0;
    border-top: 25px solid transparent;
    border-bottom: 25px solid transparent;
    border-left: 20px solid #e4e4e4;
    z-index: 1;
}

.step.active {
    background-color: #ff9800;
    color: #fff;
}

.step.active.with-arrow::after {
    border-left-color: #ff9800;
}`, "",{"version":3,"sources":["webpack://./src/components/multi-step/step.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,8BAA8B;IAC9B,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;IACrB,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,yBAAyB;IACzB,WAAW;IACX,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf;;;;;qBAKiB;IACjB,cAAc;IACd,uCAAuC;AAC3C;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,MAAM;IACN,YAAY;IACZ,QAAQ;IACR,kCAAkC;IAClC,qCAAqC;IACrC,+BAA+B;IAC/B,UAAU;AACd;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,0BAA0B;AAC9B","sourcesContent":[".step-progress {\n    display: flex;\n    width: 100%;\n    overflow-x: auto;\n    overflow-y: hidden;\n    font-family: Arial, sans-serif;\n    padding: 0px;\n    border-radius: 0px;\n}\n\n.step-progress::-webkit-scrollbar {\n    height: 8px;\n}\n\n.step-progress::-webkit-scrollbar-track {\n    background: #ddd;\n    border-radius: 4px;\n}\n\n.step-progress::-webkit-scrollbar-thumb {\n    background-color: #ff9800;\n    border-radius: 4px;\n    border: 2px solid #ccc;\n}\n\n.step-progress {\n    scrollbar-width: thin;\n    scrollbar-color: #ff9800 #ddd;\n}\n\n.step {\n    position: relative;\n    padding: 6px 20px;\n    background-color: #e4e4e4;\n    color: #333;\n    font-weight: bold;\n    font-size: 11px;\n    text-align: center;\n    min-width: 85px;\n    clip-path: polygon(0% 0%,\n            calc(100% - 20px) 0%,\n            100% 50%,\n            calc(100% - 20px) 100%,\n            0% 100%,\n            20px 50%);\n    flex-shrink: 0;\n    transition: background 0.3s, color 0.3s;\n}\n\n.step.with-arrow::after {\n    content: \"\";\n    position: absolute;\n    right: 0;\n    top: 0;\n    height: 100%;\n    width: 0;\n    border-top: 25px solid transparent;\n    border-bottom: 25px solid transparent;\n    border-left: 20px solid #e4e4e4;\n    z-index: 1;\n}\n\n.step.active {\n    background-color: #ff9800;\n    color: #fff;\n}\n\n.step.active.with-arrow::after {\n    border-left-color: #ff9800;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
